"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.saveCurrentAccountData = exports.loadCurrentAccountData = exports.initiatePasswordReset = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _accountDataApi = require("../../../../api-factory/accountDataApi");
var _CacheHandler = _interopRequireDefault(require("../../../../utils/CacheHandler"));
var _accountDataReducerTypes = require("../types/accountDataReducerTypes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {
    id: '',
    firstName: '',
    mobilNumber: '',
    email: '',
    salutation: '',
    lastName: '',
    emailConfirmed: '',
    has2FactorAuthEnabled: false,
    apps: []
  },
  isRequestPending: false,
  resetData: false,
  errorCode: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _accountDataReducerTypes.AccountDataActionTypes.LOAD_ACCOUNT_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data
      });
    case _accountDataReducerTypes.AccountDataActionTypes.SAVE_ACCOUNT_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data
      });
    case _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: true
      });
    case _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET_DONE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: false,
        resetData: action.resetData
      });
    case _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET_ERROR:
      {
        var _action$error;
        return _objectSpread(_objectSpread({}, state), {}, {
          isRequestPending: false,
          errorCode: (_action$error = action.error) === null || _action$error === void 0 ? void 0 : _action$error.code
        });
      }
    default:
      return state;
  }
}
var initiatePasswordReset = exports.initiatePasswordReset = function initiatePasswordReset(dispatch, values) {
  dispatch({
    type: _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET
  });
  return (0, _accountDataApi.resetPasswordInitiate)(values).then(function (response) {
    if (response.status === 201) {
      dispatch({
        type: _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET_DONE,
        resetData: true
      });
    }
  }).catch(function (error) {
    var _error$response, _error$response$data, _error$response$data$;
    dispatch({
      type: _accountDataReducerTypes.AccountDataActionTypes.INITIATE_PASSWORD_RESET_ERROR,
      resetData: false,
      error: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.pop()
    });
    throw error;
  });
};
var loadCurrentAccountData = exports.loadCurrentAccountData = function loadCurrentAccountData(dispatch) {
  return (0, _accountDataApi.getAccountData)().then(function (response) {
    dispatch({
      type: _accountDataReducerTypes.AccountDataActionTypes.LOAD_ACCOUNT_DATA,
      data: response && response.data
    });
  });
};
var saveCurrentAccountData = exports.saveCurrentAccountData = function saveCurrentAccountData(dispatch, accountData) {
  return (0, _accountDataApi.saveAccountData)(accountData).then(function () {
    var updatedAccountData = updateAccountData(accountData);
    _CacheHandler.default.saveCache({
      accountData: updatedAccountData
    });
    dispatch({
      type: _accountDataReducerTypes.AccountDataActionTypes.SAVE_ACCOUNT_DATA,
      data: updatedAccountData
    });
  }).catch(function (error) {
    var _error$response2, _error$response2$data;
    throw (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.errors;
  });
};
function updateAccountData(accountData) {
  var oldData = _CacheHandler.default.getCurrentCacheByToken('accountData');
  var emailData = {};
  if (accountData.email) {
    if (oldData.oldEmail === accountData.email) {
      emailData = {
        emailConfirmed: true,
        oldEmail: null
      };
    } else if (!oldData.emailConfirmed) {
      emailData = {
        emailConfirmed: false,
        email: accountData.email
      };
    } else {
      emailData = {
        emailConfirmed: false,
        oldEmail: oldData.email
      };
    }
  }
  return _objectSpread(_objectSpread(_objectSpread({}, oldData), accountData), emailData);
}